<template>
    <div class="row-fill container-col">
      <vue-headful :title="'مُرَيجَع | ' + lemposToLemma(lempos)"/>
      <collocation-overview :lempos="lempos" class="row-fill"/>
    </div>
</template>

<script>
import CollocationOverview from '../components/CollocationOverview.vue'
import vueHeadful from 'vue-headful'
import { api } from '../mixins/api.js'

export default {
  name: 'LemmaView',
  mixins: [ api ],
  props: {
    lempos: String
  },
  components: {
    CollocationOverview,
    vueHeadful
  }
}
</script>

<style scoped>
</style>
